import React from 'react';
import { isEqual } from 'lodash';
import { Col, Divider, Row } from 'antd';

import {
  WorkerHistoryDetailsModel,
  WorkerHistoryRequest,
} from 'api/adminApiClient';
import HistoryField from '../../HistoryField';
import HistoryLog from '../../HistoryLog';
import { getWorkerTypeLabel } from 'utils/workerUtils';

import styles from '../../HistoryCard.module.less';

type Props = {
  historyDetails: WorkerHistoryDetailsModel;
  historyId: string;
};

export default function WorkerTypeDetailsCard(props: Props) {
  const { historyDetails, historyId } = props;
  const { oldData, newData } = historyDetails;

  const hasTaxIdChanged = !isEqual(oldData?.taxId || '', newData?.taxId || '');

  const hasWorkerTypeChanged = !isEqual(
    oldData?.workerType || '',
    newData?.workerType || '',
  );

  const hasWorkerTypeSectionChanged = hasTaxIdChanged || hasWorkerTypeChanged;

  const renderWorkerType = (worker?: WorkerHistoryRequest) => {
    if (!worker) return null;

    const { workerType, taxId } = worker;
    const sectionName = 'worker-type';

    return (
      <>
        <Row gutter={[10, 10]}>
          <Col xs={24}>
            <div className={styles.cardTitle}>Worker type</div>
          </Col>
          {hasWorkerTypeChanged && (
            <HistoryField
              title="Worker type"
              value={getWorkerTypeLabel(workerType)}
              dataId={`${sectionName}-worker-type-field`}
            />
          )}
          {hasTaxIdChanged && (
            <HistoryField
              title="Tax ID"
              value={taxId}
              dataId={`${sectionName}-tax-id-field`}
            />
          )}
        </Row>

        <Divider />
      </>
    );
  };

  if (!hasWorkerTypeSectionChanged) return null;

  return (
    <HistoryLog
      historyId={historyId}
      oldData={renderWorkerType(oldData)}
      newData={renderWorkerType(newData)}
    />
  );
}
